<template>
    <div class="animated fadeIn">

      <b-nav fill>
        <b-nav-item :active="tabInfo=='A'" @click="tabInfo='A'">Dados do Associado</b-nav-item>
        <b-nav-item :active="tabInfo=='S'" @click="tabInfo='S'">Informações Adicionais</b-nav-item>        
      </b-nav>

      <div v-show="tabInfo=='A'">
        <b-card>
          <b-form @submit.stop.prevent="onSubmit">

                  <b-row>
                    <b-col md="12">
                  
                      <b-form-group
                        :description="usernameError"
                        label="Usuário"
                        label-for="username"
                        :label-cols="3"
                        :horizontal="true">
                        <b-input-group class="mb-3">
                          <b-input-group-prepend>
                            <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                          </b-input-group-prepend>
                          <b-form-input  v-model="username" ref="username" type="text" class="form-control" :class="usernameField" required placeholder="Usuário / E-mail" autocomplete="username" 
                            readonly
                            />
                        </b-input-group>
                      </b-form-group>          

                    </b-col>
                  </b-row>

                  <b-row v-show="!this.selectedItem.id || this.selectedItem.id <= 0">
                    <b-col md="12">
                  
                      <b-form-group
                        :description="passwordError"
                        label="Senha"
                        label-for="passord"
                        :label-cols="3"
                        :horizontal="true">
                        <b-input-group class="mb-3">
                          <b-input-group-prepend>
                            <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                          </b-input-group-prepend>
                          <b-form-input v-model="password" ref="password" type="password" :class="passwordField" class="form-control" required placeholder="Senha" 
                          @blur="checkPassword()"  />
                        </b-input-group>
                      </b-form-group>          

                    </b-col>
                  </b-row>

                  <b-row v-show="!this.selectedItem.id || this.selectedItem.id <= 0">
                    <b-col md="12">
                  
                      <b-form-group
                        :description="password2Error"
                        label="Confirmar senha"
                        label-for="password2"
                        :label-cols="3"
                        :horizontal="true">
                        <b-input-group class="mb-4">
                          <b-input-group-prepend>
                            <b-input-group-text><i class="icon-lock-open"></i></b-input-group-text>
                          </b-input-group-prepend>
                          <b-form-input v-model="password2" ref="password2" type="password" class="form-control" :class="password2Field" required placeholder="Confirmar senha" 
                          @blur="checkPassword()"  />
                        </b-input-group>
                      </b-form-group>          

                    </b-col>
                  </b-row>
                  
              
                  <hr>
                  <b-row>
                    <b-col md="12">
                  
                      <b-form-group
                        label="Nome completo"
                        label-for="name"
                        :label-cols="3"
                        :horizontal="true">
                        <b-input-group class="mb-3">
                          <b-input-group-prepend>
                            <b-input-group-text><i class="icon-wallet"></i></b-input-group-text>
                          </b-input-group-prepend>
                          <b-form-input  v-model="name" ref="name" type="text" class="form-control text-uppercase" :class="nameField" required placeholder="Nome completo" autocomplete="name"                       
                          />
                        </b-input-group>
                      </b-form-group>          

                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                  
                      <b-form-group
                        :description="emailError"
                        label="E-mail"
                        label-for="email"
                        :label-cols="3"
                        :horizontal="true">
                        <b-input-group class="mb-3">
                          <b-input-group-prepend>
                            <b-input-group-text>@</b-input-group-text>
                          </b-input-group-prepend>
                          <b-form-input v-model="email" ref="email" type="text" class="form-control" :class="emailField" required placeholder="E-mail" autocomplete="email" 
                          />
                        </b-input-group>
                      </b-form-group>          

                    </b-col>
                  </b-row>

                  
                  <b-row>
                    <b-col md="12">
                  
                      <b-form-group
                        label="Telefone"
                        label-for="phone"
                        :label-cols="3"
                        :horizontal="true">
                        <b-input-group>
                          <div class="input-group-prepend">
                              <span class="input-group-text">
                              <i class='fa fa-phone'></i>
                              </span>
                          </div>
                          <masked-input
                              type="tel"
                              name="phone"
                              class="form-control"
                              :class="phoneField"
                              v-model="phone"
                              :mask="['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                              :guide="true"
                              placeholderChar="_"
                              aria-placeholder="Telefone (Whatsapp)">
                          </masked-input>
                          </b-input-group>
                      </b-form-group>          

                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                  
                      <b-form-group
                        label="Empresa"
                        label-for="company"
                        :label-cols="3"
                        :horizontal="true">
                        <b-input-group class="mb-3">
                          <b-input-group-prepend>
                            <b-input-group-text><i class="icon-briefcase"></i></b-input-group-text>
                          </b-input-group-prepend>
                          <b-form-input  v-model="companyName" ref="company" type="text" class="form-control text-uppercase" :class="companyField" required placeholder="Nome da empresa"   />
                        </b-input-group>
                      </b-form-group>          

                    </b-col>
                  </b-row>

                  <hr>

                  <b-row>
                    <b-col md="12">
                  
                      <b-form-group
                        description=""
                        label="Ramo de atividade"
                        label-for="activityBranch"
                        :label-cols="3"
                        :horizontal="true">
                        <b-input-group class="mb-3">
                          <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-cubes"></i></b-input-group-text>
                          </b-input-group-prepend>
                          <b-form-select id="activityBranch"
                            v-model="activityBranchId"
                            :plain="true"
                            :options="selectActivityBranchDDL"
                            :value="[null,'c']">
                          </b-form-select>
                        </b-input-group>
                      </b-form-group>          

                    </b-col>
                  </b-row>

                  <b-row v-show="isManager || selectedItem.user.id == $store.state.currentUser.id">
                    <b-col md="12">
                  
                      <b-form-group
                        description="Entre com a porcentagem de comissão fixa por indicação"
                        label="Comissão fixa"
                        label-for="comission"
                        :label-cols="3"
                        :horizontal="true">
                        <b-row>
                          <b-col md="4">
                            <b-input-group class="mb-3">
                              <b-input-group-prepend>
                                <b-input-group-text><i class="fa fa-percent"></i></b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-input  v-model="comission" ref="comission" type="number" class="form-control" />
                            </b-input-group>
                          </b-col>
                        </b-row>
                      </b-form-group>   

                    </b-col>
                  </b-row>

                  <b-row v-show="isManager || selectedItem.user.id == $store.state.currentUser.id">
                    <b-col md="12">
                  
                      <b-form-group
                        description="Entre com a porcentagem de comissão por recorrência"
                        label="Comissão por recorrência"
                        label-for="monthlyComission"
                        :label-cols="3"
                        :horizontal="true">
                        <b-row>
                          <b-col md="4">
                            <b-input-group class="mb-3">
                              <b-input-group-prepend>
                                <b-input-group-text><i class="fa fa-percent"></i></b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-input  v-model="monthlyComission" ref="monthlyComission" type="number" class="form-control" />
                            </b-input-group>                            
                          </b-col>
                        </b-row>      
                      </b-form-group>

                    </b-col>
                  </b-row>

                  <b-row v-show="isManager || selectedItem.user.id == $store.state.currentUser.id">
                    <b-col md="12">
                  
                      <b-form-group
                        description="Dia de vencimento da recorrência"
                        label="Vencimento"
                        label-for="paymentDay"
                        :label-cols="3"
                        :horizontal="true">
                        <b-row>
                          <b-col md="4">
                            <b-input-group class="mb-3">
                              <b-input-group-prepend>
                                <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-input  v-model="paymentDay" ref="paymentDay" type="number" min="1" max="31" class="form-control" required placeholder="Dia do pagamento" />
                            </b-input-group>
                          </b-col>
                        </b-row>
                      </b-form-group>          

                    </b-col>
                  </b-row>

                  <b-row v-show="isManager || selectedItem.user.id == $store.state.currentUser.id">
                    <b-col md="12">
                  
                      <b-form-group
                        description=""
                        label="Chave PIX"
                        label-for="pixKey"
                        :label-cols="3"
                        :horizontal="true">
                     
                            <b-input-group class="mb-3">
                              <b-input-group-prepend>
                                <b-input-group-text><i class="fa fa-key"></i></b-input-group-text>
                              </b-input-group-prepend>
                              <b-form-input  v-model="pixKey" ref="pixKey" type="text" class="form-control" />
                            </b-input-group>
                        
                      </b-form-group>          

                    </b-col>
                  </b-row>

                  <hr v-show="isManager || selectedItem.user.id == $store.state.currentUser.id">

                  <b-row v-show="isManager || selectedItem.user.id == $store.state.currentUser.id">
                    <b-col md="12">
                  
                      <b-form-group
                        description=""
                        label="Indicação"
                        label-for="sponsorName"
                        :label-cols="3"
                        :horizontal="true">
                        <b-input-group class="mb-3">
                          <b-input-group-prepend>
                            <b-input-group-text><i class="icon-compass"></i></b-input-group-text>
                          </b-input-group-prepend>
                          <b-form-input  v-model="sponsorName" ref="sponsorName" type="text" class="form-control" required placeholder="Nome de quem indicou" />
                        </b-input-group>
                      </b-form-group>          

                    </b-col>
                  </b-row>

                  <b-row v-show="isManager || selectedItem.user.id == $store.state.currentUser.id">
                    <b-col md="12">
                  
                      <b-form-group
                        description="Selecione o patrocinador de acordo com o nome em Indicação."
                        label="Patrocinador"
                        label-for="serviceUser"
                        :label-cols="3"
                        :horizontal="true">
                        
                          <b-form-select id="sponsor"
                            v-model="sponsorId"
                            :plain="true"
                            :options="selectSponsorDDL"
                            :value="[null,'c']">
                          </b-form-select>

                      </b-form-group>          

                    </b-col>
                  </b-row>
                  

   
            
          </b-form>
        </b-card>

        <div slot="footer" class="text-right">
            <b-button variant="danger" @click="cancelButton()" v-show="isManager"><i class="fa fa-close"></i> {{ selectedItem.statusId == 2 ? 'Reabrir inscrição' : 'Cancelar Inscrição' }} </b-button>
            &nbsp;
            <b-button variant="primary" @click="saveRegistration()" v-show="isManager || selectedItem.user.id == $store.state.currentUser.id"><i class="fa fa-check"></i> Salvar Associado</b-button>
          </div>
      </div>

      <div v-show="tabInfo=='S'">
        <b-card>

          <b-form @submit.stop.prevent="onSubmit">

          <b-form-group
            label="Serviços"
            label-for="service"
            :horizontal="false">
            <textarea v-model="services" class="form-control" id="services" name="body" rows="4" placeholder=""></textarea>
          </b-form-group>

          <b-form-group
            label="Público alvo"
            label-for="targetAudience"
            :horizontal="false">
            <textarea v-model="targetAudience" class="form-control" id="targetAudience" name="body" rows="4" placeholder=""></textarea>
          </b-form-group>
            
          </b-form>

          <b-card header="Redes Sociais" v-if="selectedItem && selectedItem.user">
            <user-social-network-component :userId="selectedItem.user.id"></user-social-network-component>
          </b-card>       
        </b-card>
           
        <div slot="footer" class="text-right">
            <b-button @click="saveUserData()" variant="primary" v-show="isManager || selectedItem.user.id == $store.state.currentUser.id"><i class="fa fa-dot-circle-o"></i> Salvar Informações Adicionais</b-button>
          </div>
      </div>

      <b-modal
        v-model="editModal"
        id="edit-modal"
        centered
        hide-footer
        title="Cancelar Inscrição"
        size="md">
          
        <b-form @submit.stop.prevent="onSubmit">

          <b-form-group
            label="Motivo do Cancelamento"
            label-for="cancelReason"
            :horizontal="false">
            <textarea v-model="cancelReason" class="form-control" id="cancelReason" name="body" rows="6" placeholder="" :class="cancelReasonClass"></textarea>
          </b-form-group>
        
        </b-form>
        
        <div class="text-right">
          <b-button @click="cancelRegistration()" variant="primary"><i class="fa fa-dot-circle-o"></i> Cancelar Inscrição</b-button>   
        </div>

        
      </b-modal>

      
    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";
import MaskedInput from 'vue-text-mask'
import UserSocialNetworkComponent from '../sys/UserSocialNetworkComponent.vue';

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  export default {
    name: 'RegistrationUserComponent',
    props: {
        // Objeto USER
       item: {},
       isManager: false
    },
    computed: {
      selectSponsorDDL: function() {
          var list = [...this.sponsorDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '' })
          return list
      },
      selectActivityBranchDDL: function() {
          var list = [...this.activityBranchDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '' })
          return list
      },
      selectedItem() {
        this.groupUserId = this.item.id
        this.companyId = this.item.group.companyId
        this.userId = this.item.user.id
        this.companyName = this.item.companyName
        this.name = this.item.user.name
        this.phone = this.item.user.phone
        this.username = this.item.user.username
        this.email = this.item.user.email
        this.activityBranchId = this.item.activityBranchId
        this.paymentDay = this.item.paymentDay
        this.comission = this.item.comission
        this.monthlyComission = this.item.monthlyComission
        this.pixKey = this.item.pixKey
        this.statusId = this.item.statusId
        this.sponsorName = this.item.sponsorName
        this.sponsorId = this.item.sponsorId ? this.item.sponsorId : 0
        
        return this.item
      }
    },
    components: {
      MaskedInput,
      UserSocialNetworkComponent
    },
    data: () => {
      return {
        editModal: false,
        cancelReason: '',
        cancelReasonClass: '',

        tabInfo: 'A',
        services: '',
        targetAudience: '',

        sponsorDDL: [],
        activityBranchDDL: [],

        passwordPolicy: /^.{8,}$/,
        passwordPolicyMessage: 'No mínimo 8 caracteres',

        errormessage: '',
        
        companyName: '',
        companyField: '',
        
        name: '',
        nameField: '',
        
        phone: '',
        phoneField: '',

        username: '',
        usernameError: '',
        usernameField: '',

        email: '',
        emailError: '',
        emailField: '',

        password: '',
        passwordError: '',
        passwordField: '',

        password2: '',
        password2Error: '',
        password2Field: '',

        activityBranchId: 0,
        activityBranchField: '',

        paymentDay: '',
        comission: '',
        monthlyComission: '',
        pixKey: ''
      }
    },
    methods: {
        async saveNewAccount() {
          var s = this;
          this.errormessage = '';
          var currentUser = this.$store.state.currentUser

          var data = {
            "id": this.groupUserId,
            "companyId": this.companyId,
            "username": this.username,
            "companyName": this.companyName,
            "fullname": this.name,
            "email": this.email,
            "phone": this.phone,
            "activityBranchId": this.activityBranchId,
            "comission": this.comission,
            "monthlyComission": this.monthlyComission,
            "paymentDay": this.paymentDay,
            'pixKey': this.pixKey,
            "sponsorName": this.sponsorName,
            "sponsorId": this.sponsorId,
            'services': this.services,
            'targetAudience': this.targetAudience,
            'uid': currentUser.id,
            'sid': currentUser.sid
          }

          await axios.post(
              this.$store.state.ws_url + "/franchise/group/user/change",
              data          
          ).then(function(resp) {
              s.$emit('resp',{ code: 1, message: 'Usuário alterado com sucesso' })
          })
          .catch(function (error) {
            console.log(error)
            toast ({
                type: VueNotifications.types.error,
                title: 'Dados do Associado',
                message: 'Erro ao alterar dados do associado.',
                timeout: 3000
            })
          });


        },

        async checkUsername() {
            var s = this
        
            if(s.username && s.username.length > 0) {
                    await axios.get(
                    s.$store.state.ws_url + "/user/check/username/" + s.username
                ).then(function(resp) {
                    console.log(resp)
                    s.usernameField = resp.data.obj > 0 ? 'is-invalid' : ''
                    s.usernameError = resp.data.obj > 0 ? resp.data.message : ''

                }).catch(function(error) {
                    s.usernameError = ''
                    s.usernameField = ''
                })
            }
       
        },

        async checkEmail() {
        var s = this
        
        if(this.email && this.email.length > 0) {
            if(this.$utils.checkEmail(this.email)) {
            //console.log(this.$store.state.ws_url + "/user/check/email/" + this.email)

            await axios.get(
                this.$store.state.ws_url + "/user/check/email/" + this.email
            ).then(function(resp) {
                console.log(resp)
                s.emailField = resp.data.obj > 0 ? 'is-invalid' : ''
                s.emailError = resp.data.obj > 0 ? resp.data.message : ''
                
            }).catch(function(error) {
                s.emailError = ''
                s.emailField = ''
            })
            }
            else {
            s.emailError = 'E-mail inválido. Verifique e tente novamente'
            s.emailField = 'is-invalid'
            }
        }
        else {
            s.emailError = ''
            s.emailField = ''
        }
        

        },

        checkPassword() {
            var s = this
            if(this.password && this.password.length > 0) {
                if(this.passwordPolicy.test(this.password)) {
                s.passwordField = ''
                s.passwordError = ''

                if(this.password2 && this.password2.length > 0) {
                    s.password2Field = this.password === this.password2 ? '' : 'is-invalid'
                    s.password2Error = this.password === this.password2 ? '' : 'Senhas diferentes. Verifique e tente novamente.'
                }
                }
                else {
                s.passwordField = 'is-invalid'
                s.passwordError = this.passwordPolicyMessage
                }
            }
            else {
                s.passwordField = ''
                s.passwordError = ''
            }
        
        },

        saveRegistration() {
          var containsError = false

          if(this.name == '') {
            this.nameField = 'is-invalid'
            containsError = true
          }
          else {
            this.nameField = ''
          }
         
          if(this.email == '') {
            this.emailField = 'is-invalid'
            containsError = true
          }
          else {
            this.emailField = ''
          }
            
          if(this.phone == '') {
            this.phoneField = 'is-invalid'
            containsError = true
          }
          else {
            this.phoneField = ''
          }
          
          if(this.companyName == '') {
            this.companyField = 'is-invalid'
            containsError = true
          }
          else {
            this.companyField = ''
          }

          if(!containsError) {
              this.saveNewAccount()
          }
        
        
        },

        backToPortal() {
        this.$router.push({ path: '/dashboard' })
        },
        backLogin() {
        this.$router.push({ path: '/pages/login' })
        },

        async getActivityBranch() {
          var s = this
          var currentUser = this.$store.state.currentUser

          await axios.get(
              this.$store.state.ws_url + "/activitybranch/ddl?companyId=" + this.$store.state.config.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
              s.activityBranchDDL = resp.data.obj
          }).catch(function(error) {
              console.log(error)
          })
        },

        async getPreferences() {
        
          var s = this
          await axios.get(
              this.$store.state.ws_url + "/sys/preference/password/policy?companyId=" + this.$store.state.config.companyId
          ).then(function(resp) {
              s.passwordPolicy = new RegExp(resp.data.obj.stringPreference)
              s.passwordPolicyMessage = resp.data.obj.description
          }).catch(function(error) {
              s.passwordPolicy = /^.{8,}$/
          })
        },

        async getGroupUser() {
            var s = this;
            var currentUser = this.$store.state.currentUser;            
            await axios.get(
                this.$store.state.ws_url + "/franchise/group/user/ddl?companyId=" + this.$store.state.config.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.sponsorDDL = resp.data.obj;
            }
            ).catch(function (error) {
                console.log(error.message);            
            });

        },

        async saveUserData() {
          var currentUser = this.$store.state.currentUser;

          var postData = {
            id: this.userId,
            userId: this.userId,
            services: this.services,
            targetAudience: this.targetAudience,
            uid: currentUser.id,
            sid: currentUser.sid
          }

          await axios.post(
            this.$store.state.ws_url + "/user/data",
            postData
          ).then(function(resp) {
            toast ({
                type: VueNotifications.types.success,
                title: 'Dados do Usuário',
                message: 'Informações adicionais salvas.',
                timeout: 3000
            })
          }).catch(function(error) {
            toast ({
                type: VueNotifications.types.error,
                title: 'Dados do Usuário',
                message: 'Erro ao salvar informações adicionais.',
                timeout: 3000
            })
          })
          
        },

        async getUserData() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.services = ""
          this.targetAudience = ""

          await axios.get(
              this.$store.state.ws_url + "/user/data?userId=" + this.userId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.services = resp && resp.data && resp.data.obj && resp.data.obj.services ? resp.data.obj.services : ""
              s.targetAudience = resp && resp.data && resp.data.obj && resp.data.obj.targetAudience ? resp.data.obj.targetAudience : ""
          }
          ).catch(function (error) {
              console.log(error.message);            
          });

        },

        async cancelRegistration() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          var containsError = false
          if(!this.cancelReason || this.cancelReason.length < 3) {
            this.cancelReasonClass = 'is-invalid'
            containsError = true
          }
          else {
            this.cancelReasonClass = ''
          }

          if(!containsError) {
            await axios.get(
              this.$store.state.ws_url + "/franchise/group/user/cancel?companyId=" + this.companyId + "&notes=" + encodeURI(this.cancelReason) + "&groupUserId=" + this.groupUserId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
              s.$emit('resp', { code: 1, message: 'Inscrição cancelada' })
            }).catch(function(error) {
              toast ({
                type: VueNotifications.types.error,
                title: 'Inscrição',
                message: 'Erro ao cancelar inscrição',
                timeout: 3000
            })
            })
          }

        },

        async reopenRegistration() {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          await axios.get(
            this.$store.state.ws_url + "/franchise/group/user/reopen?companyId=" + this.companyId + "&groupUserId=" + this.groupUserId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.$emit('resp', { code: 1, message: 'Inscrição reaberta' })
          }).catch(function(error) {
            toast ({
                type: VueNotifications.types.error,
                title: 'Inscrição',
                message: 'Erro ao reabrir inscrição',
                timeout: 3000
            })
          })

        },

        cancelButton() {
          if(this.item.statusId == 2) {
            this.reopenRegistration()            
          }
          else {
            this.editModal = true
          }          
        }

    },

    mounted: function() {
        this.getPreferences()
        this.getActivityBranch()
        this.getGroupUser()
        this.getUserData()
    }
  }


</script>